import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Grid, IconButton, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import BuyList from "../BuyList";
import Success from "components/Success";
import { useNavigate } from "react-router";
import Details from "../Details";
import { getAllBuyLeadsApi } from "store/api";

function TabPanel (props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps (index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function BuyTab () {
  const navigate = useNavigate();
  const [msg, setMsg] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [openView, setOpenView] = React.useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [queryDetails, setQueryDetails] = React.useState({});

  const handleClickOpenView = data => {
    setQueryDetails(data);
    setOpenView(true);
  };
  const handleCloseView = data => {
    setOpenView(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [debounceTimeout, setDebounceTimeout] = React.useState(null);

  const [buyLeads, setBuyLeads] = React.useState([]);

  // Fetch API results
  const FetchBuyLeads = async searchTerm => {
    const params = !searchTerm
      ? {}
      : {
          searchKeyword: searchTerm,
        };
    try {
      const response = await getAllBuyLeadsApi(params);
      if (response?.success) {
        setBuyLeads(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleChangeCustom = async e => {
    const { value } = e.target;
    if (debounceTimeout) clearTimeout(debounceTimeout);
    const newTimeout = setTimeout(() => {
      FetchBuyLeads(value);
    }, 500);
    setDebounceTimeout(newTimeout);
  };

  React.useEffect(() => {
    FetchBuyLeads();
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant='h5' onClick={() => navigate("/custom-battery")}>
          Buy {value ? "Category" : "Leads"}
        </Typography>
        {value == 0 && (
          <div
            style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}
          >
            <TextField
              placeholder='Search here...'
              InputProps={{
                endAdornment: (
                  <IconButton color='inherit'>
                    <Search />
                  </IconButton>
                ),
              }}
              onChange={handleChangeCustom}
              style={{ backgroundColor: "", borderRadius: "4px" }}
            />
          </div>
        )}
      </div>

      <Box>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {buyLeads?.length == 0 && <div>No Leads Found</div>}
            {buyLeads?.length > 0 && (
              <BuyList buyLeads={buyLeads} active={0} handleClickOpenView={handleClickOpenView} />
            )}
          </Grid>
        </TabPanel>
      </Box>
      <Details open={openView} queryDetails={queryDetails} handleClose={handleCloseView} />
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </div>
  );
}
